import { Injectable } from "@angular/core";
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { HttpErrorHandler } from '../../../utils/http-error-handler'
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../model';
import { ResponseHandler } from "../../../utils/responce-handler";

@Injectable()
export class ApiResponseService {

    constructor(private http: HttpClient) {
    }
    EOL_URL = environment.eol_url;
    /* public getCurrentVehiclesInspections() {
        return this.http.get<Response<any>>(`${this.EOL_URL}/current/vehicles/inspections`).pipe(
            map(data => {
                data = ResponseHandler.processData<any>(data);
                return {
                    inspectionId: data[0][0].inspectionId,
                    vin: data[0][0].assemblyVehicle.vin
                }
            }, catchError(HttpErrorHandler.handleError))
        )
    } */

    /**
     * getVehicleInspectionChecklists
     */
    public getVehicleInspectionChecklists(vin: string, inspectionId: string) {
        return this.http.get<ApiResponse<any>>(`${this.EOL_URL}/vehicles/${vin}/inspection/${inspectionId}/checklists`).pipe(
            map(data => {
                return ResponseHandler.processData<any>(data);
            }, catchError(HttpErrorHandler.handleError))
        )
    }

    /**
     * getVinVehicleDetail
     */
    public getVinVehicleDetail(vin: string) {
        return this.http.get<ApiResponse<any>>(`${this.EOL_URL}/vehicles/vin/${vin}`).pipe(
            map(data => {
                return ResponseHandler.processData<any>(data);
            }, catchError(HttpErrorHandler.handleError))
        )
    }

    /**
     * getVinVehicleInspection
     */
    public getVinVehicleInspection(vin: string) {
        return this.http.get<ApiResponse<any>>(`${this.EOL_URL}/vehicles/vin/${vin}/inspection`).pipe(
            map(data => {
                return ResponseHandler.processData<any>(data);
            }, catchError(HttpErrorHandler.handleError))
        )
    }
}